@import '../../styles/mixins/_btalk-mixins.scss';
@import '../../styles/variables/_btalk-variables.scss';
@import '../../styles/classes.scss';
@import '../../styles/buttons.scss';
@import '../../styles/header-nav.scss';

.fa, .fab, .fal, .far, .fas,
.fa-solid, .fa-thin, .fa-sharp, .fa-regular {
 color: #818181;
 font-family: "Font Awesome 6 Pro";
}
.btalk-wrap-footer.btalk-sitemain-footer {
    background-color: $bt_footer_menu;
    padding: 60px 0;
    .btalk-widgets-grid {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        -webkit-box-align: stretch;
        -ms-flex-align: stretch;
        align-items: stretch;
        list-style: none;
        div {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 240px;
            flex: 0 0 240px;
            text-align: left;
            h4.h-widget {
                color: $color__primary-button-text;
                font-family: $font__bt-medium;
                font-size: 16px;
                //font-weight: 900;
                letter-spacing: normal;
                margin-bottom: 10px;
                text-shadow: none;
            }
            .menu {
                border: 0;
                list-style: none;
                margin: 0;
                overflow: visible;
                padding: 0;
                li {
                    padding: 4px 0;
                    a {
                        color: $color__primary-button-text;
                        font-family: $font__bt-reg;
                        font-size: 14px;
                        font-weight: 500;
                        text-shadow: none;
                        padding: 5px 5px 5px 0;
                        cursor: pointer;
                        text-decoration: none;
                    }
                    :hover{
                        text-decoration: underline;
                    }
                }
            }
        }
    }
    .btalk-container.width, .btalk-list-grid.width {
        width: 92%;
        margin: 0 auto;
        max-width: 1440px;
    }
}
.btalk-colophon.btalk-bottom-footer {
    background-color: transparent;
    border-top: 0;
    padding: 1em 0 1em;
    .btalk-container.width, .btalk-list-grid.width {
        width: 92%;
        margin: 0 auto;
    }
    .wrap {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        text-align: left;
        .btalk-colophon-content {
            -webkit-box-flex: 1;
            -ms-flex: 1 0 80%;
            flex: 1 0 80%;
            font-size: 14px;
            font-family: $font__bt-light;
            a{
                color: $color__primary-button-text;
                text-decoration: none;

            }
            .site-footer-colophon{
                display: flex;
                color: $color__primary-button-text;
                .bt-footer-nav {
                    display: inline-block;
                }
                ul{
                    li {
                        display: inline-block;
                        margin-right: 16px;
                        a{
                            color: $color__primary-button-text;
                            &:hover{
                                text-decoration: underline;
                            }
                        }
                    }
                }
            }

        }
        .btalk-social-icons {
            margin-top: 0;
            a{
                width: 41px;
                text-align: center;
                display: inline-block;
            }
            svg{
                width: 30px;
                height: auto;
                fill: #f5f5f5;
                &:hover{
                    fill: $bt-default;
                }
            }
        }
    }

}
